export default [
    {
        id: 8,
        name: 'Cobertura de la cuota',
        alert: '> 30',
        unit: '%',
        formula: '(this.form.if.expenses.credits/this.form.if.incomes.total)*100',
        info:'(Cuotas créditos recibidos por la unidad familiar / Total ingresos familiares)',
        restriction: null
    },
]
